"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockchainForChainId = exports.getBlockchainFromChain = exports.getChainFromID = exports.parseBlockchain = exports.chainIdsByBlockchain = exports.CHAIN_IDS_TEST = exports.CHAIN_IDS_DEV = exports.CHAIN_IDS = exports.ChainNames = exports.BRIDGE_IDS = exports.Blockchain = void 0;
const network_1 = require("../constant/network");
var Blockchain;
(function (Blockchain) {
    Blockchain["Neo"] = "neo";
    Blockchain["Ethereum"] = "eth";
    Blockchain["BinanceSmartChain"] = "bsc";
    Blockchain["Zilliqa"] = "zil";
    Blockchain["Native"] = "native";
    Blockchain["Btc"] = "btc";
    Blockchain["Carbon"] = "carbon";
    Blockchain["Switcheo"] = "switcheo";
    Blockchain["TradeHub"] = "tradehub";
    Blockchain["PolyNetwork"] = "polynetwork";
    Blockchain["Neo3"] = "neo3";
    Blockchain["Osmosis"] = "osmosis";
    Blockchain["Ibc"] = "ibc";
    Blockchain["Terra"] = "terra";
    Blockchain["CosmosHub"] = "cosmoshub";
    Blockchain["Juno"] = "juno";
    Blockchain["Evmos"] = "evmos";
    Blockchain["Axelar"] = "axelar";
})(Blockchain = exports.Blockchain || (exports.Blockchain = {}));
;
exports.BRIDGE_IDS = {
    'polynetwork': 1,
    'ibc': 2,
};
exports.ChainNames = {
    1: 'MainNet',
    3: 'Ropsten',
    4: 'Rinkeby',
    56: 'BSC MainNet',
    97: 'BSC TestNet',
    110: 'ZIL DevNet',
    111: 'ZIL TestNet',
};
exports.CHAIN_IDS = {
    'native': 0,
    'btc': 1,
    'eth': 2,
    'neo': 4,
    'bsc': 6,
    'neo3': 14,
    'zil': 18,
    'osmosis': 244,
    'terra': 245,
    'cosmoshub': 246,
    'juno': 247,
    'evmos': 248,
    'axelar': 249,
};
exports.CHAIN_IDS_DEV = {
    'eth': 350,
    'neo': 5,
    'neo3': 88,
    'bsc': 79,
    'zil': 111,
};
exports.CHAIN_IDS_TEST = {
    'eth': 2,
    'neo': 5,
    'neo3': 88,
    'bsc': 79,
    'zil': 111,
};
exports.chainIdsByBlockchain = {
    [network_1.Network.MainNet]: exports.CHAIN_IDS,
    [network_1.Network.DevNet]: exports.CHAIN_IDS_DEV,
    [network_1.Network.TestNet]: exports.CHAIN_IDS_TEST,
    [network_1.Network.LocalHost]: exports.CHAIN_IDS_TEST,
};
function parseBlockchain(value) {
    var _a;
    if (value === null || value === undefined)
        return null;
    return (_a = Object.values(Blockchain).find((enumMember) => enumMember.toLowerCase() === value.toLowerCase())) !== null && _a !== void 0 ? _a : null;
}
exports.parseBlockchain = parseBlockchain;
function getChainFromID(id) {
    return Object.keys(exports.CHAIN_IDS).find((key) => exports.CHAIN_IDS[key] === id);
}
exports.getChainFromID = getChainFromID;
const getBlockchainFromChain = (chainId) => {
    switch (chainId) {
        case 1:
        case 3:
        case 4:
            return Blockchain.Ethereum;
        case 56:
        case 97:
            return Blockchain.BinanceSmartChain;
        case 110:
        case 111:
            return Blockchain.Zilliqa;
    }
    return undefined;
};
exports.getBlockchainFromChain = getBlockchainFromChain;
const blockchainForChainId = (chainId) => {
    switch (chainId) {
        case 0:
            return Blockchain.Native;
        case 1:
            return Blockchain.Btc;
        case 2:
        case 350: // devnet
            return Blockchain.Ethereum;
        case 4:
        case 5: // devnet
            return Blockchain.Neo;
        case 6:
        case 79: // devnet
            return Blockchain.BinanceSmartChain;
        case 9: // mainnet
        case 18:
        case 110: // testnet
        case 111:
            return Blockchain.Zilliqa;
        case 14: // mainnet
        case 88: // testnet
            return Blockchain.Neo3;
        case 244: // mainnet
            return Blockchain.Osmosis;
        case 245: // mainnet
            return Blockchain.Terra;
        case 246: // mainnet
            return Blockchain.CosmosHub;
        case 247: // mainnet
            return Blockchain.Juno;
        case 248: // mainnet
            return Blockchain.Evmos;
        case 249: // mainnet
            return Blockchain.Axelar;
        default:
            return undefined;
    }
};
exports.blockchainForChainId = blockchainForChainId;
